import React, { useEffect } from 'react';
import { UTLabel, UTLoading } from '@widergy/energy-ui';
import { connect } from 'react-redux';
import { bool, string } from 'prop-types';
import { push } from 'connected-react-router';
import { getURLParams } from '@widergy/web-utils/lib/browser';

import { message } from 'utils/stringUtils';
import { actionCreators as paymentActions } from 'redux/paymentHandlers';
import { ROUTES } from 'constants/routes';
import { currentUserPropTypes } from 'redux/authHandlers';
import Topbar from 'app/components/Topbar';

import { NIS, AGENT_TRANSACTION_ID } from './constants';
import Form from './components/Form';
import styles from './styles.module.scss';

const PaymentForNis = ({ loading, dispatch, location, currentUser, sessionLoading }) => {
  const handleSubmit = async value => {
    await dispatch(paymentActions.getAccountUnpaid({ client_number: value.clientNumber }));
  };

  useEffect(() => {
    if (!sessionLoading && !loading) {
      if (currentUser) {
        dispatch(push(ROUTES.EXTERNAL_DOCUMENT_PAYMENTS));
      } else dispatch(push(ROUTES.PUBLIC_PAYMENT_DOCUMENTS));
    }
  }, [sessionLoading, loading, currentUser]);

  useEffect(() => {
    if (location) {
      const params = getURLParams(location.search, NIS, AGENT_TRANSACTION_ID);
      if (params[NIS]) {
        handleSubmit({ clientNumber: params[NIS] });
      } else {
        return dispatch(push(ROUTES.PUBLIC_DASHBOARD));
      }
      if (params[AGENT_TRANSACTION_ID]) {
        dispatch(paymentActions.setAgentTransaction(params[AGENT_TRANSACTION_ID]));
      }
    }
    return () => undefined;
  }, []);

  return (
    <div className={styles.container}>
      <Topbar isPublic inMaintenance />
      <div className={styles.loadingContainer}>
        <UTLoading loading={loading || sessionLoading}>
          <UTLabel className={styles.description}>{message('Payments:paymentsDetail')}</UTLabel>
          <Form onSubmit={handleSubmit} />
        </UTLoading>
      </div>
    </div>
  );
};

PaymentForNis.propTypes = {
  loading: bool,
  location: string,
  currentUser: currentUserPropTypes,
  sessionLoading: bool
};

const mapStateToProps = store => ({
  loading: store.payment.accountUnpaidLoading,
  location: store.router.location,
  currentUser: store.auth.currentUser,
  sessionLoading: store.auth.sessionLoading
});

export default connect(mapStateToProps)(PaymentForNis);
